/*
  Applies the increase_50 / increase_30 image zoom on Boost's app proxy search
  pages (/a/search/...). Those pages get their product card HTML from the
  published theme via Boost's server rather than from the theme files being
  rendered, so the Liquid in product-grid-item.liquid cannot reach them. Product
  tags are read from the storefront product JSON instead.
*/
(function () {
  if (window.location.pathname.indexOf('/a/search') !== 0) return;

  var CACHE_PREFIX = 'product-media-zoom:';
  var MAX_PARALLEL = 4;
  var queue = [];
  var active = 0;

  function readCache(handle) {
    try {
      return window.sessionStorage.getItem(CACHE_PREFIX + handle);
    } catch (e) {
      return null;
    }
  }

  function writeCache(handle, zoom) {
    try {
      window.sessionStorage.setItem(CACHE_PREFIX + handle, zoom);
    } catch (e) {}
  }

  function zoomFromTags(tags) {
    var joined = (tags || []).join(',').toLowerCase();
    if (joined.indexOf('increase_50') !== -1) return '50';
    if (joined.indexOf('increase_30') !== -1) return '30';
    return '0';
  }

  function applyZoom(mask, zoom) {
    if (zoom === '0' || mask.className.indexOf('product-media-zoom') !== -1) return;
    mask.className += ' product-media-zoom product-media-zoom--' + zoom;
  }

  function handleFromCard(mask) {
    var link = mask.closest ? mask.closest('a[href*="/products/"]') : null;
    if (!link) return '';
    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function next() {
    if (!queue.length || active >= MAX_PARALLEL) return;
    var job = queue.shift();
    active++;
    window
      .fetch('/products/' + job.handle + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        var zoom = product ? zoomFromTags(product.tags) : '0';
        writeCache(job.handle, zoom);
        job.masks.forEach(function (mask) {
          applyZoom(mask, zoom);
        });
      })
      .catch(function () {})
      .then(function () {
        active--;
        next();
      });
    next();
  }

  function scan() {
    var masks = document.querySelectorAll('.grid-product__image-mask:not(.product-media-zoom)');
    var pending = {};

    Array.prototype.forEach.call(masks, function (mask) {
      if (mask.getAttribute('data-media-zoom-checked')) return;
      var handle = handleFromCard(mask);
      if (!handle) return;
      mask.setAttribute('data-media-zoom-checked', 'true');

      var cached = readCache(handle);
      if (cached !== null) {
        applyZoom(mask, cached);
        return;
      }
      if (!pending[handle]) pending[handle] = [];
      pending[handle].push(mask);
    });

    Object.keys(pending).forEach(function (handle) {
      queue.push({ handle: handle, masks: pending[handle] });
    });
    next();
  }

  function watch() {
    var grid = document.querySelector('.boost-pfs-filter-products');
    if (!grid || !window.MutationObserver) return;
    var timer;
    new window.MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(scan, 100);
    }).observe(grid, { childList: true, subtree: true });
  }

  function init() {
    if (!window.fetch || !document.querySelectorAll) return;
    scan();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
